import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { authenticateWithGhl } from "../../marketplace/auth";

// SSO entry — the URL GHL loads the app at. We do the SSO handshake here (this
// frame's parent IS GHL, so postMessage works), store the signed token, then
// client-side navigate to the account's dashboard. Single frame — no nesting,
// no #tk handoff, no cross-frame relay.
const AppEntry = () => {
  const [state, setState] = useState<"loading" | "denied">("loading");
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    authenticateWithGhl().then((r) => {
      if (cancelled) return;
      if (r) navigate(`/${r.accountId}/dashboard`, { replace: true });
      else setState("denied");
    });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="h-screen w-full bg-white relative">
      {state === "loading" ? (
        <div className="h-full w-full flex flex-col items-center justify-center gap-3">
          <Loader2 className="h-10 w-10 animate-spin text-gray-700" />
          <div className="text-lg font-medium text-gray-800">Authenticating…</div>
          <div className="text-sm text-gray-500">
            Please wait while we verify your session
          </div>
        </div>
      ) : (
        <div className="h-full w-full flex flex-col items-center justify-center gap-2">
          <ShieldAlert className="h-10 w-10 text-red-500" />
          <div className="text-lg font-semibold text-gray-800">No Access</div>
          <div className="text-sm text-gray-500">
            We couldn't verify your session. Reopen the app from your CRM.
          </div>
        </div>
      )}
    </div>
  );
};

export default AppEntry;
